import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, LifeBuoy, Mail } from 'lucide-react';

// Self-service reset by email is BUILT but switched off — see
// FORGOT_PASSWORD_SETUP.html. Until an SMTP mailbox is configured, this screen
// tells people who to ask instead of collecting an address and silently doing
// nothing with it. To turn the email flow back on, restore the form version of
// this file from git history; the backend endpoints are already live.

// Who staff should contact. One place to change it.
const SUPPORT_EMAIL = 'info@tecgs.com';

export default function ForgotPassword() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a1424] via-[#16294d] to-[#060b16] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="w-24 h-24 bg-white rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-xl p-2">
            <img src="/cartello-logo.png" alt="Cartello Software Solutions" className="max-w-full max-h-full object-contain" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-1">Cartello Software Solutions</h1>
          <p className="text-blue-100 font-medium">Password help</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-5">
            <LifeBuoy className="w-7 h-7 text-[#2563eb]" />
          </div>

          <h2 className="text-lg font-semibold text-gray-800 mb-3">Forgot your password?</h2>

          <p className="text-sm text-gray-600 leading-relaxed">
            Passwords are reset by your administrator. Please contact them and they will set a new
            one for you straight away.
          </p>

          <a
            href={`mailto:${SUPPORT_EMAIL}?subject=Password%20reset%20request&body=Please%20reset%20the%20password%20for%20my%20account%3A%20`}
            className="mt-6 inline-flex items-center justify-center gap-2 w-full bg-gradient-to-r from-[#2563eb] to-[#1e40af] text-white py-3 rounded-lg font-semibold hover:from-[#1d4ed8] hover:to-[#1e3a8a] transition-all"
          >
            <Mail className="w-5 h-5" /> Email the administrator
          </a>

          <p className="text-xs text-gray-500 mt-3">{SUPPORT_EMAIL}</p>

          <div className="mt-6 pt-5 border-t border-gray-100">
            <p className="text-xs text-gray-500 leading-relaxed">
              Once you are signed in you can change your own password any time from
              <strong className="text-gray-700"> My Profile</strong>.
            </p>
          </div>

          <Link
            to="/employee/login"
            className="inline-flex items-center gap-2 mt-6 text-sm text-[#2563eb] font-semibold hover:text-[#0a5c34]"
          >
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
        </div>

        <div className="text-center mt-6">
          <p className="text-blue-100 text-sm">© 2026 Cartello Software Solutions</p>
        </div>
      </div>
    </div>
  );
}
